import { TextWithHighlights } from "./TextWithHighlights";

## Basic Usage

<TextWithHighlights
  text="The quick brown fox jumps over the lazy dog."
  highlightedStrings={["fox", "dog"]}
  highlightClassName=""
/>

---

## Search Result Highlighting

export function SearchHighlight() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem" }}>
        <div style={{ fontWeight: 500, marginBottom: "0.25rem" }}>
          <TextWithHighlights
            text="Introduction to React Hooks"
            highlightedStrings={["React"]}
            highlightClassName=""
          />
        </div>
        <div style={{ fontSize: "14px", color: "#666" }}>
          <TextWithHighlights
            text="Learn how to use React Hooks to manage state and side effects in functional components."
            highlightedStrings={["React"]}
            highlightClassName=""
          />
        </div>
      </div>
      <div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem" }}>
        <div style={{ fontWeight: 500, marginBottom: "0.25rem" }}>
          <TextWithHighlights
            text="React Components Best Practices"
            highlightedStrings={["React"]}
            highlightClassName=""
          />
        </div>
        <div style={{ fontSize: "14px", color: "#666" }}>
          <TextWithHighlights
            text="Best practices for building reusable React components with TypeScript."
            highlightedStrings={["React"]}
            highlightClassName=""
          />
        </div>
      </div>
    </div>
  );
}

<SearchHighlight />

---

## Multiple Highlights

<TextWithHighlights
  text="JavaScript and TypeScript are both popular programming languages for web development."
  highlightedStrings={["JavaScript", "TypeScript", "web"]}
  highlightClassName=""
/>

---

## Case Insensitive Matching

The highlighting is case-insensitive:

<TextWithHighlights
  text="React, REACT, and react are all matched."
  highlightedStrings={["react"]}
  highlightClassName=""
/>

---

## Custom Highlight Style

<style>{`
  .custom-highlight {
    background: linear-gradient(120deg, #ffd54f 0%, #ffb300 100%);
    padding: 0 2px;
    border-radius: 2px;
    font-weight: 500;
  }
  .search-highlight {
    background: #bbdefb;
    border-radius: 2px;
  }
`}</style>

<div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
  <div>
    <span style={{ color: "#666", marginRight: "0.5rem" }}>Yellow gradient:</span>
    <TextWithHighlights
      text="Important keywords are highlighted"
      highlightedStrings={["Important", "highlighted"]}
      highlightClassName="custom-highlight"
    />
  </div>
  <div>
    <span style={{ color: "#666", marginRight: "0.5rem" }}>Blue background:</span>
    <TextWithHighlights
      text="Search terms are easy to spot"
      highlightedStrings={["Search", "easy"]}
      highlightClassName="search-highlight"
    />
  </div>
</div>

---

## No Matches

When no strings match, the text is returned unchanged:

<TextWithHighlights
  text="This text has no matching terms."
  highlightedStrings={["nothing", "here"]}
  highlightClassName=""
/>

---

## Empty Highlight Array

<TextWithHighlights
  text="No highlights specified for this text."
  highlightedStrings={[]}
  highlightClassName=""
/>

---

## Autocomplete Suggestion

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "0.5rem" }}>
  <div style={{ padding: "0.5rem", borderBottom: "1px solid #e5e5e5" }}>
    <TextWithHighlights text="JavaScript" highlightedStrings={["Java"]} highlightClassName="" />
  </div>
  <div style={{ padding: "0.5rem", borderBottom: "1px solid #e5e5e5" }}>
    <TextWithHighlights text="Java" highlightedStrings={["Java"]} highlightClassName="" />
  </div>
  <div style={{ padding: "0.5rem" }}>
    <TextWithHighlights text="Jakarta" highlightedStrings={["Ja"]} highlightClassName="" />
  </div>
</div>


